import {
  LOAD_DASHBOARD_SUCCESS_PP,
  GET_MESSAGE_BOARD_SUCCESS,
  GET_MESSAGE_BOARD_ERROR,
  GET_DASHBOARD_ACTIONS_PP_SUCCESS,
  GET_DASHBOARD_ACTIONS_PP_ERROR,
  GET_INSURANCE_ADS_BEGIN,
  GET_INSURANCE_ADS_SUCCESS,
  GET_INSURANCE_ADS_ERROR,
} from "actions/dashboardActionsPP";
import { SUBMIT_CHARITY_SURVEY_SUCCESS } from "actions/charityActions";

const initialState = {
  loading: true,
  all: [],
  byId: {},
  pageFieldsById: {},
  dashboardData: null,
  dashboardActions: null,
  messageBoardData: null,
  insuranceAdsData: null,
  error: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_DASHBOARD_SUCCESS_PP: {
      return {
        ...state,
        loading: false,
        dashboardData: action.payload,
      };
    }
    case GET_MESSAGE_BOARD_SUCCESS: {
      return {
        ...state,
        loading: false,
        messageBoardData: action.payload,
        error: null,
      };
    }
    case GET_MESSAGE_BOARD_ERROR: {
      return {
        ...state,
        loading: false,
        messageBoardData: null,
        error: action.payload,
      };
    }
    case GET_DASHBOARD_ACTIONS_PP_SUCCESS: {
      return {
        ...state,
        loading: false,
        dashboardActions: action.payload,
        error: null,
      };
    }
    case GET_DASHBOARD_ACTIONS_PP_ERROR: {
      return {
        ...state,
        loading: false,
        dashboardActions: null,
        error: action.payload,
      };
    }
    case SUBMIT_CHARITY_SURVEY_SUCCESS: {
      return {
        ...state,
        loading: false,
        byId: { ...state.byId, ...action.payload },
      };
    }
    case GET_INSURANCE_ADS_BEGIN:
      return { ...state, fetching: true, error: null };
    case GET_INSURANCE_ADS_SUCCESS: {
      return {
        ...state,
        loading: false,
        insuranceAdsData: action.payload,
        error: null,
      };
    }
    case GET_INSURANCE_ADS_ERROR: {
      return {
        ...state,
        loading: false,
        insuranceAdsData: null,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./reducers/dashboardReducerPP.js